import { Component, OnInit, inject } from '@angular/core';
import {
  UntypedFormGroup,
  FormGroup,
  FormControl,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogModule,
} from '@angular/material/dialog';
import { RightBridgeApiService } from '../services/right-bridge-api.service';
import { EnvironmentService } from '../services/environment.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-attest-dialog',
  templateUrl: './attest-dialog.component.html',
  styleUrls: ['./attest-dialog.component.scss'],
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
  ],
})
export class AttestDialogComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<AttestDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private rbs = inject(RightBridgeApiService);
  private envSvc = inject(EnvironmentService);

  private environment;
  form: FormGroup;
  usersName = null;
  docUrl = null;

  ngOnInit() {
    this.environment = this.envSvc.get();

    const formGroup = new UntypedFormGroup({
      nameInput: new FormControl(''),
    });
    this.form = formGroup;
    const parser = document.createElement('a');
    parser.href = this.environment.apiBase;
    this.docUrl = `https://ra.rightbridge.net/v3/assets/license-agreement.pdf`;
  }

  accept() {
    const data = this.form.value.nameInput;
    if (data) {
      this.rbs.signLicenseAgreement(this.form.value.nameInput).subscribe(() => {
        this.close(data);
      });
    } else {
      this.form.markAsTouched();
    }
  }

  close(formData = 'cancel') {
    this.dialogRef.close({ data: formData });
    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
  }
}
